import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import VeeValidate from 'vee-validate';
import ToggleButton from 'vue-js-toggle-button';
import CKEditor from 'ckeditor4-vue';
import VueAnalytics from 'vue-analytics'
import { googleAnalyticsKey } from './properties';
import axios from 'axios';
import 'whatwg-fetch';
import VueSimpleSVG from 'vue-simple-svg'
Vue.use(VueSimpleSVG)
// Vue.use(axios); //Commenting out broken/improper axios plugin
Vue.use(ToggleButton);
Vue.use(VeeValidate);
Vue.use( CKEditor );
Vue.use(VueAnalytics, {
  id: googleAnalyticsKey
})

import { BFormDatepicker } from 'bootstrap-vue';
Vue.component('b-form-datepicker', BFormDatepicker)
Vue.config.devtools = true

axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
  }, function (error) {
	  return error;
  });


window.$ = require('jquery')
window.JQuery = require('jquery')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
